import { supabase } from '@/lib/supabase';

// Thin wrapper around the log_platform_admin_action RPC (see migration
// 0103) -- every Superadmin screen that writes something worth
// remembering calls this right after the write succeeds. The RPC stamps
// actor_user_id from the caller's own session server-side, so this can't
// be used to forge who did something. Best-effort: a logging failure
// shouldn't undo or block the action it's describing, so errors are
// swallowed (logged to console) rather than surfaced to the user.
export async function logPlatformAdminAction(
  action: string,
  targetType: string,
  targetId?: string | null,
  detail?: Record<string, unknown> | null
) {
  const { error } = await supabase.rpc('log_platform_admin_action', {
    p_action: action,
    p_target_type: targetType,
    p_target_id: targetId ?? null,
    p_detail: detail ?? null,
  });
  if (error) console.error('[platformAuditLog] failed to log action:', action, error);
}
